import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RotatePlayLogo from '../components/RotatePlayLogo';

export default function ConfirmEmail() {
  const { confirmEmail, resendCode } = useAuth();
  const navigate      = useNavigate();
  const [params]      = useSearchParams();

  const [email,   setEmail]   = useState(params.get('email') ?? '');
  const [code,    setCode]    = useState('');
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleConfirm(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await confirmEmail(email.trim().toLowerCase(), code.trim());
      navigate('/login?confirmed=1', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Confirmation failed');
    } finally {
      setLoading(false);
    }
  }

  async function handleResend() {
    setError('');
    setSuccess('');
    try {
      await resendCode(email.trim().toLowerCase());
      setSuccess('A new code has been sent to your email.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not resend code');
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <RotatePlayLogo />
        </div>

        <div className="card">
          <div className="card-title">Verify Your Email</div>
          <p style={{ fontSize: '.875rem', color: 'var(--gray-600)', marginBottom: 16 }}>
            We sent a 6-digit code to <strong>{email || 'your email'}</strong>.
          </p>

          {error   && <div className="alert alert-red">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleConfirm} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {!params.get('email') && (
              <div>
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={{ marginTop: 4 }}
                />
              </div>
            )}
            <div>
              <label>Verification Code</label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
                placeholder="123456"
                required
                style={{ marginTop: 4, letterSpacing: '0.25em', fontSize: '1.25rem' }}
              />
            </div>

            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Verifying…' : 'Verify Email'}
            </button>
          </form>

          <div style={{ marginTop: 16, fontSize: '.875rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <button
              className="btn btn-secondary btn-sm"
              type="button"
              onClick={handleResend}
            >
              Resend code
            </button>
            <Link to="/login" style={{ color: 'var(--gray-500)' }}>Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
